import { CustomersInput, CustomersOutput } from "../interfaces/customers";
import { BaseService } from "./BaseService";

export class CustomerService extends BaseService<
  CustomersInput,
  CustomersOutput
> {
  constructor() {
    super();
    this.path = "customers";
  }

  async metricCount(): Promise<number> {
    const url = `${this.path}/metrics/count`;
    const response = await this.request<number>(url, {
      method: "GET",
    });

    return response;
  }
}
